module.exports = __webpack_public_path__ + "media/images/flags/tt-b9a6939e2ab09927d19088bb11957702.svg";